export default "__VITE_ASSET__gwkiWQqz__"